// TODO: This should reflect src/pages folder structure
export enum Routes {
	// Generic
	Home = "/",

	// Auth / Login related pages
	Register = "/account/register",
	RegisterConfirm = "/account/confirm",
	Login = "/account/login",
	RecoverPassword = "/account/recover",
	ResetPassword = "/account/reset",

	// Statistics
	StatisticsPlatform = "/stats/platform",
	StatisticsDefaultRate = "/stats/platform/default",
	StatisticsProjects = "/stats/platform/projects",
	StatisticsPlatformSingleProject = "/stats/platform/projects/:id",
	StatisticsImpact = "/stats/impact",

	// Investments
	InvestmentsProjectsCurrentOverview = "/investments/current-overview",
	InvestmentsProjectsFiscalOverview = "/investments/fiscal-overview",
	InvestmentsProjectsProduction = "/investments/production",
	ProvisionalInvestments = "/investments/provisional",
	InvestmentsProjectsPayments = "/investments/payments",

	// Monthly overview
	InvestmentsProjectsMonthlyOverviewMain = "/investments/monthly-overview",
	InvestmentsProjectsMonthlyOverview = "/investments/monthly-overview/:date",

	// Investment Projects
	InvestmentsProjects = "/investments/projects",
	InvestmentsProjectsDashboardPaginated = "/investments/projects/page/:page",

	// Single project pages
	InvestmentsProjectDashboard = "/investments/projects/:id/dashboard",
	InvestmentsProjectRevenue = "/investments/projects/:id/revenue",
	InvestmentsProjectNotifications = "/investments/projects/:id/notifications",
	InvestmentsProjectData = "/investments/projects/:id/data",
	InvestmentsProjectCommunications = "/investments/projects/:id/communications",
	InvestmentsProjectDocumentation = "/investments/projects/:id/documentation",

	// Communications hub
	Communications = "/messages",
	CommunicationsSettingsNotifications = "/messages/settings/notifications",
	CommunicationsMessage = "/messages/:id",

	// Network
	Community = "/community",
	CommunityShare = "/community/share",

	// Finance B2B
	Finance = "/finance",
	FinanceProjects = "/finance/projects",
	FinanceInterestPayments = "/finance/interest-payments",
	FinanceSolarInterestTariff = "/finance/solar-interest-tariff",
	FinanceBondsLoan = "/finance/bonds-loan",

	// Investor profile
	InvestorProfile = "/investor",
	InvestorIdentity = "/investor/identity",
	InvestorTest = "/investor/test",
	InvestorRisk = "/investor/risk",
	InvestorFunds = "/investor/funds",

	// Settings
	AppSettings = "/settings/profile/app",
	SettingsProfilePersonalDetails = "/settings/profile",
	SettingsProfileCompanyDetails = "/settings/profile/company-details",
	SettingsProfileBankDetails = "/settings/profile/bank-details",
	SettingsProfileAccount = "/settings/profile/account",

	// Security
	SettingsProfileSecurity = "/settings/profile/security",
	SettingsProfileSecurityVerify = "/settings/profile/security/verify",
	SettingsProfileSecurityRegenerateBackupCodes = "/settings/profile/security/regenerate-backup-codes",
	Recent = "/settings/profile/activity",

	// Admin
	Info = "/settings/app/info",
}
